import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useApi } from '@/shared/api';
import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';
import { StripePaymentHistoryContent } from './StripePaymentHistoryContent';

export function StripePaymentsDialog({
  bookingId,
  open,
  onClose,
}: {
  bookingId: string;
  open: boolean;
  onClose: () => void;
}) {
  const api = useApi();
  const { t } = useTranslation('stripePayments');
  const query = useQuery({
    queryKey: ['bookings', bookingId, 'stripe-payments'],
    queryFn: () => api.bookings.prepareStripePayments(bookingId),
    enabled: open,
    retry: false,
  });
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>
          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <StripePaymentHistoryContent
            rows={query.data}
            loading={query.isPending}
            paused={query.fetchStatus === 'paused'}
            error={query.error}
            refreshing={query.isFetching}
            onRetry={() => void query.refetch()}
          />
        </DialogBody>
        <DialogFooter>
          <Button size="lg" variant="secondary" onClick={onClose}>
            {t('close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
